export const WIDGET_FILE_LIST_TYPE = 'file-list';

export const WIDGET_FILE_LIST_MAX_RESULTS = 5;
